// extracted by mini-css-extract-plugin
export default {"gridItem":"ProductCard_gridItem__wKO58","gridItem_image":"ProductCard_gridItem_image__GrdFD","details":"ProductCard_details__wc-Do"};